module.exports = __webpack_public_path__ + "static/img/ll05.7069ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ll05.png
// module id = 1+Up
// module chunks = 0